export const getNetHeatPumpCost = (
  heatPumpCost: number | null | undefined,
  heatPumpGrant: number | null | undefined
): number => {
  const grossCost = heatPumpCost ?? 0
  const grant = heatPumpGrant ?? 0

  return Math.max(grossCost - grant, 0)
}
